import gql from "graphql-tag"

export const CREATE_COMPANY = gql`
  mutation CreateCompany($input: CompanyInput!) {
    createCompany(input: $input) {
      _id
    }
  }
`;
